module.exports = __webpack_public_path__ + "img/bubble_layout_3.c6da0418.jpg";